// SAFTALicense.jsx
import React from "react";

export default function SAFTALicense() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            SAFTA License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            SAFTA Certificate for South Asian Trade Benefits
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists exporters with SAFTA Certificate of
            Origin registration for preferential tariff benefits within SAARC
            countries including Bangladesh, Nepal, Sri Lanka, and others.
          </p>
          <p className="text-gray-700">
            From Rules of Origin verification and DGFT CoO portal application to
            document authentication through EPCs/FIEO and certificate issuance,
            the process enables duty reductions and faster customs clearance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Regional trade export shipping) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/698162/pexels-photo-698162.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="SAFTA regional trade export shipping containers"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for SAFTA Certificate
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps exporters compile documentation proving
              Indian origin for SAFTA preferential tariff eligibility.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>IEC certificate (Import Export Code) from DGFT.</li>
                <li>
                  Product details including HS codes, manufacturing process,
                  value addition proof, and Rules of Origin compliance.
                </li>
                <li>
                  Export documentation comprising commercial invoice, packing
                  list, bill of lading, and manufacturer's self-declaration.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized SAFTA compliance with expertise in
              regional trade agreements and preferential tariff documentation.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Regional Trade Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of SAFTA Rules of Origin, SAARC tariff
                  schedules, DGFT CoO procedures, and preferential duty benefits
                  across South Asian markets.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Filing Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise DGFT portal applications, EPC/FIEO coordination,
                  Rules of Origin verification, and complete documentation for
                  guaranteed SAFTA certificate approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from product eligibility assessment
                  through CoO issuance, customs facilitation, and SAARC country
                  export compliance advisory for maximum tariff benefits.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
